/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { AttendanceStatus } from './AttendanceStatus';
import {
    AttendanceStatusFromJSON,
    AttendanceStatusFromJSONTyped,
    AttendanceStatusToJSON,
    AttendanceStatusToJSONTyped,
} from './AttendanceStatus';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetAttendanceLogRequest
 */
export interface GetAttendanceLogRequest {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAttendanceLogRequest
     */
    teacherId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAttendanceLogRequest
     */
    classId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAttendanceLogRequest
     */
    studentId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAttendanceLogRequest
     */
    userId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {AttendanceStatus}
     * @memberof GetAttendanceLogRequest
     */
    status: AttendanceStatus | null;
    /**
     * 
     * @type {any}
     * @memberof GetAttendanceLogRequest
     */
    fromDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetAttendanceLogRequest
     */
    toDate: any | null;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof GetAttendanceLogRequest
     */
    studentIds?: Array<ApiUserTasksGetPageParameter> | null;
}



/**
 * Check if a given object implements the GetAttendanceLogRequest interface.
 */
export function instanceOfGetAttendanceLogRequest(value: object): value is GetAttendanceLogRequest {
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('fromDate' in value) || value['fromDate'] === undefined) return false;
    if (!('toDate' in value) || value['toDate'] === undefined) return false;
    return true;
}

export function GetAttendanceLogRequestFromJSON(json: any): GetAttendanceLogRequest {
    return GetAttendanceLogRequestFromJSONTyped(json, false);
}

export function GetAttendanceLogRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttendanceLogRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'teacherId': ActorActivityRecordActorUserIdFromJSON(json['teacherId']),
        'classId': ActorActivityRecordActorUserIdFromJSON(json['classId']),
        'studentId': ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'userId': ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'status': AttendanceStatusFromJSON(json['status']),
        'fromDate': json['fromDate'],
        'toDate': json['toDate'],
        'studentIds': json['studentIds'] == null ? undefined : ((json['studentIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
    };
}

export function GetAttendanceLogRequestToJSON(json: any): GetAttendanceLogRequest {
    return GetAttendanceLogRequestToJSONTyped(json, false);
}

export function GetAttendanceLogRequestToJSONTyped(value?: GetAttendanceLogRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teacherId': ActorActivityRecordActorUserIdToJSON(value['teacherId']),
        'classId': ActorActivityRecordActorUserIdToJSON(value['classId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'status': AttendanceStatusToJSON(value['status']),
        'fromDate': value['fromDate'],
        'toDate': value['toDate'],
        'studentIds': value['studentIds'] == null ? undefined : ((value['studentIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
    };
}

